const { base64UrlEncode, generateChallenge } = require('./common');
const generateRandomBytes = require('./sync-random-bytes');


// "resolutions": {
//   "crypto-js": "3.1.9-1"
// }


function generateVerifier() {
  const bytes = generateRandomBytes().slice(0,43);

  return base64UrlEncode(bytes);
}

export const pkceChallenge = () => {
  const verifier = generateVerifier();
  const challenge = generateChallenge(verifier);

  return {
    codeChallenge: challenge,
    codeVerifier: verifier
  };
}

// module.exports = pkceChallenge;
